/* Sideways rails (product rails [data-rail] and the bag add-ons .upsells__list) for mouse users:
   - click and drag to scroll, snapping to the nearest item when let go; a drag never opens the product under it
   - ‹ › buttons on computers with a mouse/trackpad, fixed at the rail's edges, faded out at either end; only where the
     section has no arrows of its own ([data-rail-prev]/[data-rail-next] in the rail sections' headers), e.g. the bag
   Touch screens keep their own swiping and get no buttons. Rails added later (bag re-renders, recommendations
   loading in) are picked up automatically. */
(function () {
  var SEL = '[data-rail], .upsells__list';
  var fine = matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var css = '.rl-host{position:relative}' +
    '.rl-btn{position:absolute;z-index:4;top:50%;width:44px;height:44px;margin-top:-22px;padding:0;display:grid;place-items:center;' +
    'border-radius:999px;border:1px solid var(--c-line-2,rgba(255,255,255,.2));background:rgba(var(--c-bg-rgb,0,0,0),.78);' +
    '-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:var(--c-text,#fff);cursor:pointer;' +
    'box-shadow:0 6px 18px -6px rgba(0,0,0,.6);transition:opacity .2s,background-color .2s,border-color .2s}' +
    '.rl-btn:hover{background:rgba(var(--c-bg-rgb,0,0,0),.95);border-color:rgba(255,255,255,.4)}' +
    '.rl-btn:focus-visible{outline:2px solid var(--c-cream,#fff);outline-offset:2px}' +
    '.rl-btn svg{width:18px;height:18px}' +
    '.rl-btn[disabled]{opacity:0;pointer-events:none}' +
    '.rl-btn--sm{width:34px;height:34px;margin-top:-17px}.rl-btn--sm svg{width:15px;height:15px}' +
    '@media not all and (hover:hover) and (pointer:fine){.rl-btn{display:none}}' +
    '.rl-grab{cursor:grab}.rl-drag{cursor:grabbing;-webkit-user-select:none;user-select:none}' +
    '.rl-drag a,.rl-drag img{-webkit-user-drag:none}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var ico = function (d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>';
  };
  var LEFT = ico('M15 18l-6-6 6-6'), RIGHT = ico('M9 6l6 6-6 6');
  var placers = [];
  addEventListener('resize', function () {
    placers = placers.filter(function (f) { return f.list.isConnected; });
    placers.forEach(function (f) { f(); });
  }, { passive: true });

  /* where each item starts, as a scrollLeft value */
  function stops(list) {
    var lr = list.getBoundingClientRect(), pad = parseFloat(getComputedStyle(list).scrollPaddingLeft) || 0, out = [];
    for (var i = 0; i < list.children.length; i++) {
      out.push(list.children[i].getBoundingClientRect().left - lr.left + list.scrollLeft - pad);
    }
    return out;
  }
  function max(list) { return list.scrollWidth - list.clientWidth; }

  function setup(list) {
    if (list._rl) return;
    list._rl = true;
    var host = list.parentElement;
    var small = list.classList.contains('upsells__list');
    var sec = list.closest('section, product-recs, .shopify-section, .upsells');
    var own = !!(sec && sec.querySelector('[data-rail-prev], [data-rail-next]'));
    host.classList.add('rl-host');
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'rl-btn rl-prev' + (small ? ' rl-btn--sm' : '');
    next.className = 'rl-btn rl-next' + (small ? ' rl-btn--sm' : '');
    prev.setAttribute('aria-label', 'Scroll left');
    next.setAttribute('aria-label', 'Scroll right');
    prev.innerHTML = LEFT;
    next.innerHTML = RIGHT;
    prev.tabIndex = next.tabIndex = -1; /* keyboard users tab through the items themselves */
    if (!own) {
      host.appendChild(prev);
      host.appendChild(next);
    }

    /* buttons sit over the rail's edges, level with the middle of the item images (or the rail) */
    function place() {
      var hr = host.getBoundingClientRect(), lr = list.getBoundingClientRect();
      var media = list.querySelector('.card__media, img');
      var mr = media ? media.getBoundingClientRect() : lr;
      if (!mr.height) mr = lr;
      var top = mr.top + mr.height / 2 - hr.top;
      var inset = small ? 6 : 12;
      prev.style.top = next.style.top = Math.round(top) + 'px';
      prev.style.left = Math.round(lr.left - hr.left + inset) + 'px';
      next.style.left = Math.round(lr.right - hr.left - inset - (small ? 34 : 44)) + 'px';
      state();
    }
    function state() {
      var m = max(list), over = m > 2;
      prev.hidden = next.hidden = !over;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= m - 2;
      list.classList.toggle('rl-grab', over && fine.matches);
    }
    function go(dir) {
      var s = stops(list), x = list.scrollLeft, w = list.clientWidth, target;
      /* about a screenful at a time, always landing on the start of an item */
      if (dir > 0) {
        var ahead = s.filter(function (p) { return p > x + 2; });
        var fit = ahead.filter(function (p) { return p <= x + w * .9; });
        target = fit.length ? fit[fit.length - 1] : (ahead.length ? ahead[0] : max(list));
        target = Math.min(target, max(list));
      } else {
        var behind = s.filter(function (p) { return p < x - 2; });
        var back = behind.filter(function (p) { return p >= x - w * .9; });
        target = back.length ? back[0] : (behind.length ? behind[behind.length - 1] : 0);
      }
      list.scrollTo({ left: target, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    list.addEventListener('scroll', function () { requestAnimationFrame(state); }, { passive: true });
    place.list = list;
    placers.push(place);
    /* also when the rail first gets a size (e.g. the bag drawer opening) */
    if (window.ResizeObserver) new ResizeObserver(function () { place(); }).observe(list);
    list.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', place, { once: true }); });

    /* click and drag (mouse only; touch scrolls natively) */
    var down = false, moved = false, sx = 0, sl = 0, lx = 0, lt = 0, v = 0, pid = null, snapType = '';
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || max(list) <= 2) return;
      if (e.target.closest('button, select, input, label, textarea, [data-no-drag]')) return;
      down = true; moved = false; sx = lx = e.clientX; sl = list.scrollLeft; lt = performance.now(); v = 0; pid = e.pointerId;
    });
    list.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - sx;
      if (!moved) {
        if (Math.abs(dx) < 5) return;
        moved = true;
        snapType = list.style.scrollSnapType;
        list.style.scrollSnapType = 'none';
        list.style.scrollBehavior = 'auto';
        list.classList.add('rl-drag');
        try { list.setPointerCapture(pid); } catch (err) {}
      }
      var now = performance.now();
      v = (e.clientX - lx) / Math.max(1, now - lt);
      lx = e.clientX; lt = now;
      list.scrollLeft = sl - dx;
    });
    function end(e) {
      if (!down || (e && e.pointerId !== pid)) return;
      down = false;
      if (!moved) return;
      try { list.releasePointerCapture(pid); } catch (err) {}
      list.classList.remove('rl-drag');
      /* a drag must not open the product it started on */
      var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      list.addEventListener('click', block, { capture: true, once: true });
      setTimeout(function () { list.removeEventListener('click', block, true); }, 0);
      /* glide on a little, then settle on the nearest item */
      var aim = list.scrollLeft - v * 160, s = stops(list), best = s[0] || 0;
      s.forEach(function (p) { if (Math.abs(p - aim) < Math.abs(best - aim)) best = p; });
      best = Math.max(0, Math.min(best, max(list)));
      list.scrollTo({ left: best, behavior: reduce.matches ? 'auto' : 'smooth' });
      var restore = function () { list.style.scrollSnapType = snapType; list.style.scrollBehavior = ''; };
      if ('onscrollend' in window) {
        var t = setTimeout(restore, 900);
        list.addEventListener('scrollend', function () { clearTimeout(t); restore(); }, { once: true });
      } else setTimeout(restore, 500);
    }
    list.addEventListener('pointerup', end);
    list.addEventListener('pointercancel', end);
    list.addEventListener('lostpointercapture', function (e) { if (down && moved) end(e); });

    place();
    requestAnimationFrame(place);
  }

  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll(SEL).forEach(function (l) {
      if (!l.closest('.hero') && l.parentElement) setup(l);
    });
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }
  scan();
  if (window.MutationObserver) new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  addEventListener('load', function () { document.querySelectorAll(SEL).forEach(function (l) { if (l._rl) l.dispatchEvent(new Event('scroll')); }); });
})();
